<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Merge guest {{klnt.klnt_naam}} to </p>
    <v-form ref="mergeKlnt" v-model="mergeKlntValid">

     <v-row no-gutters>
      <v-col class="mx-2" cols="8">
           <v-text-field v-model="klnt_code" required label="Guest Id" :rules="klnt_codeRules"></v-text-field>
         </v-col>
     </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="mergeKlnt" :disabled="!mergeKlntValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      mergeKlntValid: false,
      klnt_encrid: null,
      klnt: {},
      klnt_code: '',
      klnt_codeRules: [
          v => !!v || "A guest ID  is required"
      ]
    }
  },
  methods: {
    open(klnt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/klnt/getKlntToMerge.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlntToMerge"
          },
          getKlntToMerge: {
            klnt_encrid: klnt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klnt = res.data.getKlntToMerge;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mergeKlnt() { 
      this.$axios
        .post("ares/json/ares/klnt/mergeKlnt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mergeKlnt"
          },
          mergeKlnt: {
            klnt_encrid: this.klnt.klnt_encrid,
            klnt_code: this.klnt_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.mergeKlnt.color == "success")
               setTimeout(() => { this.$router.reload('/klnt/onKlnt/' + res.data.mergeKlnt.klnt_encrid);  opener.location.reload(); }, 2000);                                      
                           
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.mergeKlnt.text,
              color: res.data.mergeKlnt.color
            }); 
             
            this.dialog = false;
          }
        })
    }
  }
}
</script>

